import type { ReactNode } from 'react';

export const symbol_sticky_note: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v434q0 12.44-5 23.72T822-303L657-138q-8 8-19.28 13-11.28 5-23.72 5H180Zm429-60v-83q0-35 26.5-61.5T697-351h83v-429H180v600h429ZM450-579v228q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-228h99q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H351q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h99Zm159 399Zm-429 0v-600 600Z"
		/>
	</svg>
);
